export default "__VITE_ASSET__278752e4__"